var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rounded-lg sm:rounded-xl p-4 lg:p-4 shadow bg-white grid grid-cols-5"},[_vm._m(0),_vm._v(" "),_c('div',{ref:"chart",staticClass:"col-span-4",staticStyle:{"width":"100%","height":"400px"}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-gray-700 text-4xl font-semibold"},[_vm._v("\n\t\tF-Weizen"),_c('br'),_vm._v("\n\t\t2021\n\t")])
}]

export { render, staticRenderFns }